import React from 'react';
import Dashboard from '../../pages/Dashboard';

export default function RecordsViewContainer({ records, permissions, onDeleteRecord, onEditRecord, onGrantPermission, onViewRecord }) {
  return (
    <Dashboard
      records={records}
      permissions={permissions}
      onDeleteRecord={onDeleteRecord}
      onEditRecord={onEditRecord}
      onGrantPermission={onGrantPermission}
      onViewRecord={onViewRecord}
    />
  );
}
